export default __webpack_public_path__ + "static/media/empty-state-fuel.bfbfb0e3.svg";